import React from 'react'

import { Icon, Switch } from '@app/components/util'
import { LntTag } from '@app/components/base'

import { TAG_TYPE } from '@app/constants/tag'
import { ICON_NAME } from '@app/constants/icon'
import {
  EXTERNAL_PRODUCTS_STATUS_TITLE,
  EXTERNAL_PRODUCT_STATUS
} from '@app/pages/ExternalProductsCatalogPage/сonstans'

import styles from './styles.module.scss'

import type { ExternalProductsCatalogStatusTagRenderProps } from './types'

const { Case } = Switch

export const ExternalProductsStatusTagRender: React.FC<ExternalProductsCatalogStatusTagRenderProps> = ({
  title,
  status
}) => {
  return (
    <div className={ styles.tagContainer }>
      <h4 className={ styles.tagTitle }>{ title }</h4>

      <Switch>
        <Case condition={ status === EXTERNAL_PRODUCT_STATUS.notConfirmed }>
          <div className={ styles.tagWrapper }>
            <LntTag type={ TAG_TYPE.danger }>{ EXTERNAL_PRODUCTS_STATUS_TITLE[status] }</LntTag>
          </div>
        </Case>

        <Case condition={ status === EXTERNAL_PRODUCT_STATUS.confirmed }>
          <div className={ styles.tagWrapper }>
            <LntTag type={ TAG_TYPE.success }>{ EXTERNAL_PRODUCTS_STATUS_TITLE[status] }</LntTag>
          </div>
        </Case>

        <Case condition={ status === EXTERNAL_PRODUCT_STATUS.confirmedByLenta }>
          <div className={ styles.tagWrapper }>
            <LntTag type={ TAG_TYPE.success }>{ EXTERNAL_PRODUCTS_STATUS_TITLE[status] }</LntTag>

            <Icon
              name={ ICON_NAME.confirmedByLenta }
              size='22'
            />
          </div>
        </Case>
      </Switch>
    </div>
  )
}
